//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import { isDefined } from '@utils/filterPredicates';
import { RequestError } from '@utils/sessionFetch';

const GENERAL_ERROR_MESSAGE =
  'Please try again or contact Bazaarvoice Support.';

export enum ErrorType {
  LABELS_FETCH = 'LABELS_FETCH',
  REELS_FETCH = 'REELS_FETCH',
  MEDIA_ITEMS_FETCH = 'MEDIA_ITEMS_FETCH',
}

export interface RequestErrorMessages {
  defaultMessage: string;
  notAuthorized: string;
  notFound: string;
}

const errorMessages: Record<ErrorType, RequestErrorMessages> = {
  LABELS_FETCH: {
    defaultMessage: 'An error occurred retrieving your labels.',
    notAuthorized: 'You do not have access to labels.',
    notFound: 'An error occurred.',
  },
  REELS_FETCH: {
    defaultMessage: 'An error occurred.',
    notAuthorized: 'An error occurred.',
    notFound: 'An error occurred.',
  },
  MEDIA_ITEMS_FETCH: {
    defaultMessage: 'An error occurred retrieving your media.',
    notAuthorized: 'You do not have access to media items.',
    notFound: 'An error occurred.',
  },
} as const;

export const getErrorMessage = (type: ErrorType, error: unknown) => {
  const messages = errorMessages[type];

  if (error instanceof RequestError) {
    if (isDefined(error.statusCode)) {
      switch (error.statusCode) {
        case 401:
        case 403:
          return `${messages.notAuthorized} ${GENERAL_ERROR_MESSAGE}`;
        case 404:
          return `${messages.notFound} ${GENERAL_ERROR_MESSAGE}`;
      }
    }
  }

  return `${messages.defaultMessage} ${GENERAL_ERROR_MESSAGE}`;
};
